import { ensureCsrfToken } from './csrf.js';

async function syncCsrfTokenMeta() {
    try {
        await ensureCsrfToken();
    } catch (error) {
        console.error('Failed to sync CSRF token meta tag:', error);
    }
}

const bootstrapCsrfMetaSync = () => {
    if (typeof window !== 'undefined' && window.__vsebankiLivewireManualStartEnabled) {
        return;
    }

    void syncCsrfTokenMeta();
};

if (typeof document !== 'undefined') {
    document.addEventListener('livewire:load', bootstrapCsrfMetaSync, { once: true });
}

if (typeof window !== 'undefined') {
    window.addEventListener('livewire:load', bootstrapCsrfMetaSync, { once: true });

    if (window.Livewire) {
        bootstrapCsrfMetaSync();
    }
}
